import { Box } from "@mui/material";

const Error = () => {
  return (
    <Box
      sx={{
        minHeight: `calc(100vh - 200px)`,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
      component="img"
      src="/assets/404_not_found.svg"
      alt="404 Not Found"
      sx={{
        width: "100%",
        height: "100%",
        maxWidth: "500px",
        maxHeight: "500px",
        animation: 'topToBottom 3s ease-in-out infinite',
        '@keyframes topToBottom': {
          '0%': {
            transform: 'translateY(0)',
          },
          '50%': {
            transform: 'translateY(10px)',
          },
          '100%': {
            transform: 'translateY(0)',
          },
        },
      }}
    />
    </Box>
  );
};

export default Error;
